<template>
	<Teleport to="#subheader-target">
		<div
			class="subheader"
			:class="{
				[`subheader--${modifier}`]: modifier,
			}"
		>
			<Shell>
				<slot />
			</Shell>
		</div><!-- /.subheader -->
	</Teleport>
</template>

<script>
import Shell from '@/components/shell/shell';

export default {
	/**
	 * Name
	 */
	name: 'Subheader',

	/**
	 * Components
	 */
	components: {
		Shell,
	},

	props: {
		modifier: {
			type: String,
			default: ''
		},
	},
};
</script>
